import { InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { User } from '../../user/User'
import { QueryArgs } from '../../action'

@InputType()
export class GetContactListArgs extends QueryArgs<User> {}

export interface IGetContactList extends IAction<User[], GetContactListArgs> {}
